import { Type } from "class-transformer";
import { eSoCalculatesAs } from "./absenceTypes-model";
import { AbstractJSONModel } from "./master-model";
import store from "@/store";

export enum eSalerySystem {
  Manuel = 0,
  SD = 1,
  KMD = 2,
}

export interface IInstitution {
  id: number;
  name: string;
  created_at: Date;
  updated_at: Date;
  municipality_id: number;
  institution_type_id: number;
  address: string;
  postal_district_id?: any;
  code: number | null;
  subscription_agreement_read_by_id: number | null;
  subscription_agreement_date_of_acceptance: Date | null;
  show_double_duty_button: boolean;
  email_address: string;
  show_segments: boolean;
  has_school_hours: boolean;
  market: string;
  salary_system: number;
  salary_institution_code: number | undefined;
  salary_period_end_day: number;
  uses_children_data_sharing: boolean;
  is_public: boolean;
  school_id: number;
  school_time_schedule_id: number;
  active: boolean;
  st_inside_at_on_web_accept_for_ok13: boolean;
  st_subtracts_from_pool_for_ok13: boolean;
  so_calculates_as: number;
  so_changed_by: string;
  show_future_duties_in_pending_employment: boolean;
  deduct_closed_days_from_gross_days: boolean;
  censor_all_codes_on_employee_page: boolean;

  opentime_monday: number;
  opentime_tuesday: number;
  opentime_wednesday: number;
  opentime_thursday: number;
  opentime_friday: number;
  opentime_saturday: number;
  opentime_sunday: number;
  closetime_monday: number;
  closetime_tuesday: number;
  closetime_wednesday: number;
  closetime_thursday: number;
  closetime_friday: number;
  closetime_saturday: number;
  closetime_sunday: number;
}

export interface IInstitutionPut {
  id: number;
  name: string;
  institution_type_id: number;
  address: string;
  postal_district_id?: any;
  salary_institution_code: number | undefined;
  email_address: string;
  show_future_duties_in_pending_employment: boolean;
  deduct_closed_days_from_gross_days: boolean;

  opentime_monday: number;
  opentime_tuesday: number;
  opentime_wednesday: number;
  opentime_thursday: number;
  opentime_friday: number;
  opentime_saturday: number;
  opentime_sunday: number;
  closetime_monday: number;
  closetime_tuesday: number;
  closetime_wednesday: number;
  closetime_thursday: number;
  closetime_friday: number;
  closetime_saturday: number;
  closetime_sunday: number;
}

export class Institution extends AbstractJSONModel implements IInstitution {
  public id = 0;
  public name = "";
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();
  public municipality_id = 0;
  public institution_type_id = 0;
  public address = "";
  public postal_district_id: number | null = null;
  public code: number | null = null;
  public subscription_agreement_read_by_id: number | null = null;
  @Type(() => Date)
  public subscription_agreement_date_of_acceptance: Date | null = null;
  public show_double_duty_button = false;
  public email_address = "";
  public show_segments = false;
  public has_school_hours = false;
  public market = "dk";
  public salary_system = 0;
  public salary_institution_code: number | undefined = undefined;
  public salary_period_end_day = 0;
  public uses_children_data_sharing = false;
  public is_public = false;
  public school_id = 0;
  public school_time_schedule_id = 0;
  public active = false;
  public st_inside_at_on_web_accept_for_ok13 = false;
  public st_subtracts_from_pool_for_ok13 = false;
  public so_calculates_as = 0;
  public so_changed_by = "";
  public show_future_duties_in_pending_employment = false;
  public deduct_closed_days_from_gross_days = false;
  public censor_all_codes_on_employee_page = false;
  public opentime_monday = 0;
  public opentime_tuesday = 0;
  public opentime_wednesday = 0;
  public opentime_thursday = 0;
  public opentime_friday = 0;
  public opentime_saturday = 0;
  public opentime_sunday = 0;
  public closetime_monday = 0;
  public closetime_tuesday = 0;
  public closetime_wednesday = 0;
  public closetime_thursday = 0;
  public closetime_friday = 0;
  public closetime_saturday = 0;
  public closetime_sunday = 0;

  equals(other: IInstitution): boolean {
    return other.id === this.id;
  }

  public convertToPutObject(): IInstitutionPut {
    const i: IInstitutionPut = Object.assign({});
    i.address = this.address;
    i.id = this.id;
    i.institution_type_id = this.institution_type_id;
    i.name = this.name;
    i.postal_district_id = this.postal_district_id;
    i.salary_institution_code = this.salary_institution_code;
    i.email_address = this.email_address;
    i.show_future_duties_in_pending_employment = this.show_future_duties_in_pending_employment;
    i.deduct_closed_days_from_gross_days = this.deduct_closed_days_from_gross_days;
    i.opentime_monday = this.opentime_monday;
    i.opentime_tuesday = this.opentime_tuesday;
    i.opentime_wednesday = this.opentime_wednesday;
    i.opentime_thursday = this.opentime_thursday;
    i.opentime_friday = this.opentime_friday;
    i.opentime_saturday = this.opentime_saturday;
    i.opentime_sunday = this.opentime_sunday;
    i.closetime_monday = this.closetime_monday;
    i.closetime_tuesday = this.closetime_tuesday;
    i.closetime_wednesday = this.closetime_wednesday;
    i.closetime_thursday = this.closetime_thursday;
    i.closetime_friday = this.closetime_friday;
    i.closetime_saturday = this.closetime_saturday;
    i.closetime_sunday = this.closetime_sunday;
    return i;
  }

  public static getSalerySystem(): eSalerySystem {
    const id = store.getters["institutions/getSalerySystem"]();
    const enumVal: eSalerySystem = eSalerySystem[eSalerySystem[id]];
    return enumVal;
  }

  public static isKmd(): boolean {
    const salary_system = store.getters["institutions/getSalerySystem"]();
    return salary_system === eSalerySystem.KMD;
  }

  public static isSd(): boolean {
    const salary_system = store.getters["institutions/getSalerySystem"]();
    return salary_system === eSalerySystem.SD;
  }

  public static isManuel(): boolean {
    const salary_system = store.getters["institutions/getSalerySystem"]();
    return salary_system === eSalerySystem.Manuel;
  }

  get soCalculatesAsNotSet(): boolean {
    return this.so_calculates_as === eSoCalculatesAs.NOT_SET;
  }

  get soCalculatesAsPlannedWorkhours(): boolean {
    return this.so_calculates_as === eSoCalculatesAs.PLANNEDWORKHOURS;
  }

  get soCalculatesAsNormDay(): boolean {
    return this.so_calculates_as === eSoCalculatesAs.NORMDAY;
  }
}
